<template>
  <div class="app">
    <div class="d-flex h-100 justify-content-center align-items-center">
      <div class="mx-auto app-login-box col-md-8">
        <div class="mb-3 d-flex align-items-center justify-content-center">
          <img v-show="temLogoClienteNaSessao" :src="logoCliente" alt="" width="200" class="tenant-logo brand-image mt-1 ml-3 mr-3"/>
          <img alt="logo" :src="obterLogo" width="200" class="office-logo brand-image img-fluid">
        </div>
        <div class="modal-dialog w-100 mx-auto">
          <div class="modal-content" v-if="retorno.sucesso">
            <div class="modal-body">
              <div class="d-flex flex-column align-items-center justify-content-center">
                <h4 class="font-weight-bold">Recuperação de senha realizada com sucesso!</h4>
                <p class="textos mt-3">
                  Verifique sua caixa de entrada, pois enviamos um email para <span class="text-bold" id="user-email">{{emailRecuperacao}}</span> contendo uma senha
                  temporária para acessar sua conta.
                </p>
                <p class="textos">
                  Recomendamos que você acesse sua conta o mais breve possível
                  e altere a senha temporária por uma senha segura.
                </p>
                <router-link
                  :to="{name: 'login'}"
                  :disabled="flags.efetuandoRequisicao"
                  class="small mt-3">
                  <span>Voltar para o login</span>
                </router-link>
              </div>
            </div>
          </div>
          <div class="modal-content" v-else>
            <div class="modal-body">
              <div class="modal-title">
                <div class="d-flex justify-content-center mb-3">
                  <div class="col-xl-8 col-lg-8 col-md-12 col-sm-12 d-flex justify-content-between flex-row flex-wrap">
                    <h5 class="text-left">
                      Esqueceu sua Senha?
                    </h5>
                    <div>
                      <router-link :to="{name: 'login'}" :disabled="flags.efetuandoRequisicao" class="small"><span >Voltar para o login</span></router-link>
                    </div>
                  </div>
                </div>
                <div class="avisoDanger mensagemAlerta" v-show="!retorno.sucesso">{{retorno.mensagem}}</div>
                <div v-if="recuperacaoPeloSso" id="acesso-sso" class="mt-2 mb-3">
                  <b-button variant="btn btn-secondary btn-sm botaoLogin botaoSso" @click="irParaLoginPreambulo">
                    <img :src="iconePreambulo" alt="" class="icone-sso">
                    Ir para o login Preâmbulo
                  </b-button>
                </div>
                <div v-if="flags.efetuandoRequisicao" class="divLoginSpinner mb-3">
                  <span class="avisoDanger">Por favor, aguarde...</span>
                  <b-spinner class="ml-2" variant="danger"></b-spinner>
                </div>
              </div>
              <form>
                <div v-show="flags.escritorioNaoLogado" class="input-group mb-3">
                  <input type="text" @keyup="eventoLoginTeclaEnter" autocomplete="organization" name="tenant" id="tenant" class="form-control campoSemBordaDireita corBordaCampo placeholder" v-model="dadosFormulario.tenant" placeholder="Escritório...">
                  <div class="input-group-append">
                    <div class="input-group-text fundoBotaoIcone corBordaCampo">
                      <i class="fa fa-layer-group fa-cor"></i>
                    </div>
                  </div>
                </div>
                <div v-show="flags.escritorioNaoLogado" class="avisoDanger text-left mb-2">{{retorno.listaDeErros['tenant']}}</div>
                <div class="input-group mb-3">
                  <input type="text" @keyup="eventoLoginTeclaEnter" autocomplete="username" name="identifier" id="identifier" class="form-control campoSemBordaDireita corBordaCampo placeholder" v-model="dadosFormulario.identifier" placeholder="Usuário ou E-mail...">
                  <div class="input-group-append">
                    <div class="input-group-text fundoBotaoIcone corBordaCampo">
                      <i class="fa fa-user fa-cor"></i>
                    </div>
                  </div>
                </div>
                <div class="avisoDanger text-left mb-2">{{retorno.listaDeErros['identifier']}}</div>
                <div id="acesso" class="mt-2">
                  <b-button variant="btn btn-secondary btn-sm botaoLogin" :disabled="flags.efetuandoRequisicao" @click="recuperar">Recuperar Senha</b-button>
                  <a href="#" class="linkOutroEscritorio textos" v-show="mostrarBotaoOutroEscritorio" :disabled="flags.efetuandoRequisicao" @click="acessarComOutroEscritorio">Alterar escritório para recuperação</a>
                  <p class="textos text-center">Não esqueça de verificar sua caixa de SPAM.</p>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RecuperacaoSenhaOffice from './js/recuperacaoSenhaOffice.js'
export default RecuperacaoSenhaOffice
</script>

<style scoped>
@import "./scss/login.scss";
</style>
